/*
 * Disclaimer Messages
 *
 * This contains all the text for the Disclaimer component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'DISCLAIMER.title',
    defaultMessage: 'Disclaimer',
  },
  content: {
    id: 'DISCLAIMER.content',
    defaultMessage:
      'Third Bridge Group Limited and its affiliates (together “Third Bridge”) make no representation and accept no liability for the contents of this transcript or for any errors, omissions or inaccuracies in respect of it. The views of the specialist expressed in this transcript are those of the specialist and they are not endorsed by, nor do they represent theopinion of, Third Bridge. This transcript has been produced at your request and is in respectof a consultation which took place between you and the specialist (and to which Third Bridge was not party). You must not forward this transcript to third parties other than those to employees of the Client (or its affiliates) or its professional advisors to the extent necessary.',
  },
});



// WEBPACK FOOTER //
// ./components/molecules/Disclaimer/messages.js